// extracted by mini-css-extract-plugin
export default {"root":"title_root__7NLZW","skeleton":"title_skeleton__sZ0e4","copy":"title_copy__OXKbP"};